'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateSelector = stateSelector;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var argumentRegexp = /\${args\[(\d+)]}/g;

function stateSelector() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var defaultValue = arguments[1];

    return function (state) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        if (args.length) {
            path = path.replace(argumentRegexp, function (match, p1) {
                var i = +p1;

                if ((0, _isNumber2.default)(i)) {
                    return args[i];
                }
            });
        }

        return (0, _get2.default)(state, path, defaultValue);
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/redux-saga-kit/dist/kit.js
// module id = 1037
// module chunks = 0